/**
 * Whether the Projekt-Canvas empty-state teaser should replace the task
 * board/canvas entry toolbar — true only once both tasks and canvas notes
 * have loaded (`undefined` = still loading) and both are empty, and no task
 * creator is currently open (a creator needs the task board mounted to show
 * its input). See .claude/tasks/project-canvas.md, Phase 1.
 *
 * `isMorphing` folgt demselben Grund: Nach dem Bestätigen wird der Ersteller
 * zur fertigen Zeile — und diese Animation braucht das Brett genauso. Ohne die
 * Bedingung schlug der Teaser in der Lücke zwischen „Ersteller zu" und „Aufgabe
 * in der Datenbank" zu, hängte das Brett aus und tötete den Morph mitten im
 * Lauf: `onMorphComplete` feuerte nie, die Attrappe `{ id: 'morphing' }` blieb
 * ausgewählt und ohne Funktion stehen, und die echte Aufgabe blieb dahinter
 * verborgen (`.claude/tasks/empty-state-geisterzeile.md`).
 *
 * Und nur, solange der Canvas geschlossen ist: der Teaser lädt gerade dazu
 * ein, ihn zu öffnen — steht er offen daneben, hat der Teaser seinen Zweck
 * erfüllt.
 *
 * (Diese Bedingung trug früher doppelt: Das Panel wurde bei leerem Projekt gar
 * nicht gerendert, `shouldRenderCanvasPanel` verlangte `!showEmptyStateTeaser`,
 * und ohne sie liefe das Tastenkürzel dort ins Leere. Seit ADR 0010 ist das
 * Panel auch im leeren Projekt da — nur ohne Werkzeug-Pille —, der zweite Grund
 * ist also entfallen. Der erste genügt.)
 *
 * **Ein Abschnitt beendet ihn auch** (#229): Die Pille im leeren Zustand legt
 * Abschnitte an, und ein neuer Abschnitt läge sonst hinter dem Teaser.
 * `sections` meint die gelisteten — archivierte zählen nicht.
 */
export function shouldShowCanvasEmptyState(
  tasks: unknown[] | undefined,
  canvasNotes: unknown[] | undefined,
  isCreatingTask: boolean,
  canvasIsOpen = false,
  isMorphing = false,
  sections: unknown[] | undefined = [],
): boolean {
  return (
    tasks !== undefined && canvasNotes !== undefined &&
    tasks.length === 0 && canvasNotes.length === 0 && (sections?.length ?? 0) === 0 &&
    !isCreatingTask && !canvasIsOpen && !isMorphing
  )
}
